import { Observable as ZenObservable } from "zen-observable-ts"
import { Observable } from "rxjs"

export function wrapZenObservable<T>(
    observable: ZenObservable<T>,
): Observable<T> {
    return new Observable<T>((subscriber) => observable.subscribe(subscriber))
}
